import Vue from 'vue'
import PortalVue from 'portal-vue'
import {InertiaProgress} from '@inertiajs/progress'
import {createInertiaApp} from '@inertiajs/inertia-vue'

import {ZiggyVue} from './ziggy/vue'
import FormMaking from './vue-form-making'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './styles/index.scss'
import './axios'
import {adjustColumnWidth} from './utils'
import _ from 'lodash'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.set(Vue.prototype, '$_', _)
Vue.use(ZiggyVue)
Vue.use(FormMaking)
Vue.config.productionTip = false
Vue.use(PortalVue)
Vue.set(Vue.prototype, '$window', window)



InertiaProgress.init()
Vue.use(ElementUI)
Vue.directive('fitColumns', {

  update() {
  },
  bind() {
  },
  inserted(el) {
    console.log('inserted')

    setTimeout(() => {

      adjustColumnWidth(el)
    }, 300)
  },
  componentUpdated(el) {
    // console.log('componentUpdated')
    // el.classList.add('r-table')
    // setTimeout(() => {
    //
    //   adjustColumnWidth(el)
    // }, 300)
  },
  unbind() {
  },
})

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => '湖南省小额贷款公司经营数据填报系统',
  setup({el, app, props, plugin}) {
    Vue.use(plugin)
    new Vue({render: h => h(app, props)})
      .$mount(el)
  },
})
